import AppWrapper from '../../AppWrapper';
import { APP_TYPE } from '../../constants';
import { ManagerMenu } from '../../manager/managermenu';
import { DocDtm } from '../../docs/components/DocDtm';
import { useSelector } from '../../hooks';

import { Error, ERROR_TYPE } from '../components/Error';

const PodaniDTINewPage = () => {
  const { apps } = useSelector((state) => state.app.config);

  return (
    <>
      {apps?.manager ? (
        <AppWrapper
          appType={APP_TYPE.MANAGER}
          menu={<ManagerMenu />}
          resource='RelatedApps'
          action={['allow_manager_all', 'allow_manager_dtm_dti']}
        >
          <DocDtm />
        </AppWrapper>
      ) : (
        <Error type={ERROR_TYPE.NOT_FOUND} />
      )}
    </>
  );
};

export default PodaniDTINewPage;
